"use strict";

(function () {
  'use strict';

  angular.module('lr.SideNav.directives', []).directive('lrSidenav', ['$rootScope', '$location', function ($rootScope, $location) {
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        navItems: '='
      },
      link: function link(scope, element, attrs) {
        var body = document.getElementsByTagName('BODY')[0];

        scope.getClass = function (path) {
          var tmpPath = '' + $location.path();

          if (tmpPath === path) {
            return 'lr-navigation--active';
          } else {
            return '';
          }
        };

        body.addEventListener('click', function () {
          $rootScope.$broadcast('toggle-lrSideNav');
        });
      },
      templateUrl: 'app/navigation/sidenav/lr-sidenav.html'
    };
  }]).directive('toggleSidenav', ['$rootScope', function ($rootScope) {
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        navItems: '='
      },
      link: function link(scope, element, attrs) {
        var $body = $('body');
        element.bind('click', function (e) {
          element.toggleClass('lr-nav-toggle--active');
          $body.toggleClass('lr-side-bar--open-left');
          e.stopPropagation();
        });
        $rootScope.$on('toggle-lrSideNav', function () {
          element.removeClass('lr-nav-toggle--active');
          $body.removeClass('lr-side-bar--open-left');
        });
      },
      template: '<div class="lr-nav-toggle"><span class="lr-nav-toggle__icon"></span></div>'
    };
  }]).directive('navAccordion', [function () {
    return function (scope, element, attrs) {
      element.on('click', function (e) {
        element.next('.lr-nav-button-childs').toggle();
      });
    };
  }]);
})();